import { ErrorMessage } from '@hookform/error-message';
import { forwardRef, InputHTMLAttributes, ReactNode, useEffect, useId } from 'react';
import { RegisterOptions, useFormContext } from 'react-hook-form';

type InputProps = {
  name: string;
  hints?: ReactNode;
  label?: string;
  validationOptions?: RegisterOptions;
} & InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef(
  (
    {
      name,
      disabled,
      label,

      validationOptions,

      value,
      ...rest
    }: InputProps,
    ref: any,
  ) => {
    const {
      register,
      formState: { errors },
      setFocus,
    } = useFormContext();
    // `name` can't double as the id: the profile page can have several forms
    // open at once (customer details, shipping and billing addresses), and they
    // all have a `firstName` field.
    const generatedId = useId();
    const inputId = rest.id ?? generatedId;

    useEffect(() => {
      if (rest.autoFocus) {
        setFocus(name);
      }
    }, [rest.autoFocus]);

    return (
      <>
        {Boolean(label) && <label htmlFor={inputId}>{label}</label>}
        <div>
          <input
            {...register(name, validationOptions)}
            {...(ref && { ref })}
            disabled={disabled}
            value={value}
            {...rest}
            id={inputId}
            name={name}
          />
        </div>
        <ErrorMessage
          name={name}
          errors={errors}
          as={<p className="font-medium ml-[.5rem] required-input" />}
        />
      </>
    );
  },
);
